module.exports = __webpack_public_path__ + "static/media/icon-mundon.2382495c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-mundon.svg
// module id = 158
// module chunks = 0